// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1OF_x","additionalInfo":"AgreementModal_additionalInfo__3qPqR"};